import React, { Component } from "react"
import Link from "gatsby-link"
import PropTypes from "prop-types"
import styled from "styled-components"
import { PRIMARY_TEXT, ACTIVE_TEXT } from "../components/consts/colors"
import logo from "../assets/logo.svg"

const FooterContainer = styled.footer`
  position: relative;
  padding: 50px 0;
  color: ${ACTIVE_TEXT};
  background-color: white;
  border-top: 2px solid ${ACTIVE_TEXT};

  @media screen and (max-width: 768px) {
    padding: 25px 10px;
  }
`

const FooterWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: space-between;
  a {
    transition: all 200ms ease;
    :hover {
      transform: translateY(-2px);
    }
  }

  @media (max-width: 768px) {
    width: 90%;
    flex-direction: column;
    padding-bottom: 100px;
  }

  @media (max-width: 615px) {
    width: 90%;
    flex-direction: column;
    padding-bottom: 150px;
  }
`

const FooterInfo = styled.div`
  width: 520px;
  max-width: 100%;
  a {
    padding: 5px 0px;
  }
`

const FooterForm = styled.div`
  width: 520px;
  padding-right: 20px;
  max-width: 100%;
`

const FooterSocial = styled.div`
  display: flex;
  justify-content: flex-end;
  list-style-type: none;
  padding: 0;
  margin: 0px 0px 20px 0px;
  a {
    margin-right: 20px;
    font-size: 24px;
    border: none;
  }
  @media screen and (max-width: 768px) {
    justify-content: flex-start;
    padding-top: 25px;
  }
`

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
const FooterTerms = styled(Link)``

const FooterCopyright = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  text-align: right;
  a {
    transition: all 200ms ease;
    :hover {
      transform: translateY(-2px);
    }
  }
  @media screen and (max-width: 768px) {
    text-align: left;
  }
`

const FooterMap = styled.div`
  display: flex;
  a {
    font-size: 17px;
    line-height: 28px;
  }

  @media screen and (max-width: 768px) {
    font-size: 15px;
    line-height: 19px;
  }
`

const Footer = props => {
  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterInfo>
          <img src={logo} style={{ height: "28px", marginBottom: "20px" }} />
          <FooterMap>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <FooterTerms to="/terms">TinyMerch Terms</FooterTerms>
              <a href="https://my.tinymerch.com">Seller Dashboard</a>
              <a href="mailto:team@tinymerch.com">Contact Us</a>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "60px"
              }}>
              <a href="#">TinyMerch Gallery – Coming Soon!</a>
              <a href="#">TinyMerch Docs – Coming Soon!</a>
            </div>
          </FooterMap>
        </FooterInfo>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <FooterSocial>
            <a href="https://twitter.com/tinymerch">
              <i className="fa fa-twitter" aria-hidden="true" />
            </a>
            <a href="https://facebook.com/tinymerch">
              <i className="fa fa-facebook" aria-hidden="true" />
            </a>
          </FooterSocial>
          <FooterCopyright>
            <p style={{ color: "rgba(90,88,94,1)" }}>
              Copyright <a href="http://nicer.io/">Nicer LLC</a>,{" "}
              {new Date().getFullYear()}
            </p>
            <p style={{ color: "rgba(90,88,94,1)" }}>
              Built during the{" "}
              <a href="https://www.producthunt.com/hackathon">
                ProductHunt Global Hackathon
              </a>{" "}
            </p>
          </FooterCopyright>
        </div>
      </FooterWrapper>
    </FooterContainer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/layouts/Footer.js